import Thankyou1 from '../MyComponent/Thankyou';

function thankyou() {
  return (
    <div>
      <Thankyou1 />
    </div>
  );
}

export default thankyou;
